import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { itemId: Number, favorited: Boolean, favoritableType: String };

  connect() {
    this.updateIcon();
  }

  async toggle(event) {
    event.preventDefault();
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    try {
      if (this.favoritedValue) {
        await fetch(`/favorites/${this.itemIdValue}.json`, {
          method: "DELETE",
          headers: { 
            "X-CSRF-Token": csrfToken,
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
        });
      } else {
        await fetch("/favorites.json", {
          method: "POST",
          headers: {
            "X-CSRF-Token": csrfToken,
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({ favoritable_id: this.itemIdValue, favoritable_type: this.favoritableTypeValue }),
        });
      }
      this.favoritedValue = !this.favoritedValue;
      this.updateIcon();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Favorite update failed:", error);
    }
  }

  updateIcon() {
    const tooltipTitle = this.favoritedValue ? "Remove from favorites" : "Add to favorites";
    this.element.setAttribute("title", tooltipTitle);
    this.element.setAttribute("data-bs-original-title", tooltipTitle);

    if (!this.element.classList.contains("favorite-bookmark")) return;
    this.element.style.fill = this.favoritedValue ? "currentColor" : "none";

    const tooltipInstance = bootstrap.Tooltip.getInstance(this.element);
    if (tooltipInstance) {
      tooltipInstance.setContent({ '.tooltip-inner': tooltipTitle });
    }
  } 
}
